<template>
  <div class="coa-item">
    <div class="coa__image">
      <sanity-media :image="thumb" :max-size="true" />
    </div>
    <div class="coa__content">
      <h2 class="coa__title">{{ title }}</h2>
      <div class="coa__select">
        <select-dropdown
          label="lot code"
          placeholder="select to view"
          :options="coaOptions"
          class="cart-input cart-input--dropdown"
          @input="handleClick($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectDropdown from '~/components/form/select-dropdown.vue'

export default {
  name: 'CoaItem',

  components: {
    SelectDropdown
  },

  props: {
    flavor: {
      default: null,
      type: Object,
      required: true
    }
  },

  computed: {
    title() {
      return this.flavor.name.split(' ').join('\n')
    },
    thumb() {
      return this.flavor.product.thumb.image
    },
    coaOptions() {
      return this.flavor.coas.map(function(coa) {
        return {
          key: coa.lotCode,
          value: coa.coaUrl
        }
      })
    }
  },

  methods: {
    handleClick(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.coa-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: var(--y-gutter);
  margin-left: auto;
  margin-right: auto;
  margin-top: var(--y-gutter) / 3;
  width: 100%;
}

.coa__image {
  min-width: 120px;
  width: 120px;
}

.coa__content {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  padding-left: var(--x-gutter);
}

.coa__title {
  align-self: flex-start;
  font-size: 32px;
  font-weight: theme('fontWeight.medium');
  hyphens: auto;
  line-height: theme('lineHeight.tight');
  margin-bottom: auto;
  margin-top: calc(var(--y-gutter) / 4);
  white-space: pre-wrap;
  word-break: break-word;
}

.coa__select {
  align-self: flex-start;
  padding-bottom: calc(var(--y-gutter) / 4);
}

.coa__select >>> label {
  padding-left: 0;
}

.coa__select >>> .dropdown__ui {
  margin-left: calc(var(--input-gutter) * -1);
}

@screen xs {
  .coa__image {
    min-width: 150px;
    width: 150px;
  }
}

@screen sm {
  .coa-item {
    width: 80%;
  }
}

@screen md {
  .coa__title {
    font-size: 48px;
  }

  .coa__image {
    min-width: 200px;
    width: 200px;
  }

  .coa__select {
    max-width: 300px;
  }
}

@screen lg {
  .coa-item {
    width: 60%;
  }

  .coa__image {
    min-width: 200px;
    width: 200px;
  }

  .coa__title {
    margin-top: 0;
  }

  .coa__content {
    padding-left: calc(var(--x-gutter) / 2);
  }
}

@screen xl {
  .coa-item {
    margin-top: var(--y-gutter) / 2;
    width: 680px;
  }

  .coa__image {
    min-width: 240px;
    width: 240px;
  }

  .coa__content {
    padding-left: 20px;
  }
}
</style>

<style>
.coa__image img {
  max-height: 300px;
  width: auto;
}
</style>
